import React from "react";
import Helmet from "react-helmet";
import Lightbox from "react-modal-image";

import Layout from '../components/layout';

import start from '../assets/images/start.png';
import graph from '../assets/images/user-graph1.png';

import p1 from '../assets/images/persona1.png';
import p1thumb from '../assets/images/persona1-thumb.png';
import p2 from '../assets/images/persona2.png';
import p2thumb from '../assets/images/persona2-thumb.png';
import p3 from '../assets/images/persona3.png';
import p3thumb from '../assets/images/persona3-thumb.png';

import s1 from '../assets/images/scenario1.png';
import s1thumb from '../assets/images/scenario1-thumb.png';
import s2 from '../assets/images/scenario2.png';
import s2thumb from '../assets/images/scenario2-thumb.png';
import s3 from '../assets/images/scenario3.png';
import s3thumb from '../assets/images/scenario3-thumb.png';

import lf1 from '../assets/images/v1.a.jpg';
import lf1thumb from '../assets/images/v1.a-thumb.jpg';
import lf2 from '../assets/images/v1.b.jpg';
import lf2thumb from '../assets/images/v1.b-thumb.jpg';
import lf3 from '../assets/images/v1.c.jpg';
import lf3thumb from '../assets/images/v1.c-thumb.jpg';
import lf4 from '../assets/images/v1.d.jpg';
import lf4thumb from '../assets/images/v1.d-thumb.jpg';
import lf5 from '../assets/images/v1.e.jpg';
import lf5thumb from '../assets/images/v1.e-thumb.jpg';

import hf1 from '../assets/images/hifi1.jpg';
import hf2 from '../assets/images/hifi2.jpg';
import hf3 from '../assets/images/hifi3.jpg';
import hf4 from '../assets/images/hifi4.jpg';
import hf5 from '../assets/images/hifi5.jpg';
import hf6 from '../assets/images/hifi6.jpg';
import hf7 from '../assets/images/hifi7.jpg';
import hf8 from '../assets/images/hifi8.jpg';
import hf9 from '../assets/images/hifi9.jpg';
import hf10 from '../assets/images/hifi10.jpg';

// import paper from '../assets/pdf/Group5.pdf';

class Homepage extends React.Component {
    render() {
        const siteTitle = "Newspixel";

        return (
            <Layout>
                <Helmet title={siteTitle} />

                <section id="one" className="main style1">
                    <div className="grid-wrapper">
                        <div className="col-6">
                            <header className="major">
                                <h2>NEWSPIXEL</h2>
                            </header>
                            <p>There are widespread concerns over misinformation, fake news, and propaganda found in secondary sources.<br/>
                            NEWPIXEL address this as a well as attack the following questions:</p>
                            <li>What factors contribute to the creation and spread of misinformation</li>
                            <li>How can a transmedia narractive be used to educate about misinformation?</li>
                            <br/>
                            <ul className="actions">
                                <li><a href="https://www.canva.com/design/DAEXB7Bha1A/view?utm_content=DAEXB7Bha1A&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink" target="_blank" className="button">Slides</a></li>
                            </ul>
                        </div>
                        <div className="col-6">
                            <div><h1><br/></h1></div>
                            <span className="image fit">
                                <a href="https://xd.adobe.com/view/722ae8b0-a1b1-4b3f-43ba-b5998b2a0284-041b/?fullscreen&hints=off" target='_blank'><img src={start} alt="" /></a>
                                <br/><p>Click &#8593; to see the prototype!</p>
                            </span>
                        </div>
                    </div>
                </section>

                <section id="two" className="main style2">
                    <div className="grid-wrapper">
                        <div className="col-12">
                            <header className="major">
                                <h2>MEET THE TEAM</h2>
                            </header>
                        </div>
                        <div className="col-3">
                            <header className="major">
                                <h4><strong>GINA</strong><br/>Product Owner & UI/UX Designer</h4>
                            </header>
                            <p>
                                Programming<br/>
                                UI/UX Concepts<br/>
                                Adobe CCs<br/>
                                Unity<br/>
                                Maya<br/>
                            </p>
                        </div>
                        <div className="col-3">
                            <header className="major">
                                <h4><strong>LOUIS</strong><br/><br/>Content Creator<br/></h4>
                            </header>
                            <p>
                                Programming<br/>
                                Unreal 4<br/>
                                Game Design<br/>
                            </p>
                        </div>
                        <div className="col-3">
                            <header className="major">
                                <h4><strong>MADISON</strong><br/><br/>Project Strategist<br/></h4>
                            </header>
                            <p>
                                Illustrator<br/>
                                Figma<br/>
                                Squarespace<br/>
                            </p>
                        </div>
                        <div className="col-3">
                            <header className="major">
                                <h4><strong>ROBERT</strong><br/><br/>Conctent Creator<br/></h4>
                            </header>
                            <p>
                                Programming<br/>
                                Photoshop<br/>
                                Vegas<br/>
                                Unity<br/>
                                Audacity
                            </p>
                        </div>
                    </div>
                </section>

                <section id="three" className="main style1">
                    <div className="grid-wrapper">
                        <div className="col-12">
                            <header className="major">
                                <h2>BRAINSTORMING</h2>
                            </header>
                            <h4><strong>64%</strong><br/>of the U.S.adults said misinformation caused a confusion about the facts of current events<br/></h4>
                        </div>
                        <div className="col-4">
                            <h4><strong>CONTEXT & CONTRAINTS</strong></h4>
                            <ul className="align-left">
                                <li>We noticed that people discuss news without knowing what happened</li>
                                <li>We derive context form our interactions with fake news and social media</li>
                                <li>It is challengin to correct behaviros and information processing in people</li>
                            </ul>
                        </div>
                        <div className="col-4">
                            <h4><strong>TASKS</strong></h4>
                            <ul className="align-left">
                                <li>Help determin whether the information is legitimate of at least make them wuestion information</li>
                                <li>Raise the publi's awawreness of the amount of misinformation</li>
                                <li>Teach how misinformation is mutated and spread</li>
                            </ul>
                        </div>
                        <div className="col-4">
                            <h4><strong>PROTOTYPE IDEAS</strong></h4>
                            <ul className="align-left">
                                <li>A portal that verifies misinformation</li>
                                <li>Intentionally produce a transmedia game to show how misinformation</li>
                                <li>Create an SNS account and post misinformation</li>
                            </ul>
                        </div>
                    </div>
                </section>

                <section id="one" className="main style2">
                    <div className="grid-wrapper">
                        <div className="col-6">
                            <header className="major">
                                <h2>USERS</h2>
                            </header>
                            <h3><strong>Teenagers ~ Mid 30s</strong></h3>
                            <p>According to research, more than 50% of transmedia users are 16 -35 years old.<br/>
                                Since we are looking for the problem of misinformation on transmedia, we thought we should focus on the people who use transmedia heavily. 
                                So, we decided to set our target user age range from teenagers to mid-30s Most of our users will be high school students and college students.<br/>
                                Since transmedia is accessible anywhere in the world as long as the internet works, we will not specify the location of the users to a certain region.<br/>
                                Our game will be a web-based game, so the users will be able to play it either on PC or their mobile devices.<br/>
                            </p>
                        </div>
                        <div className="col-6">
                            <h3 className="align-center"><br/></h3>
                            <span className="image fit"><img src={graph} alt="" /></span>
                        </div>
                    </div>
                </section>

                <section id="four" className="main style1">
                    <div className="grid-wrapper">
                        <div className="col-12">
                            <header className="major">
                                <h2>PERSONAS, SCENARIO & STORYBOARD</h2>
                            </header>
                            <p>Click the image to see the detail</p>
                        </div>
                        <div className="col-4">
                            <h3 className="align-center"><strong>PERSONA 1</strong></h3>
                            <span className="image fit">
                            <Lightbox
                                small={p1thumb}
                                large={p1}
                                hideDownload="true"
                                 alt="Persona 1: Wai"/></span>
                                 <span className="image fit">
                            <Lightbox
                                small={s1thumb}
                                large={s1}
                                hideDownload="true"
                                 alt="Scenario 1: Wai"/></span>
                        </div>
                        <div className="col-4">
                            <h3 className="align-center"><strong>PERSONA 2</strong></h3>
                            <span className="image fit">
                            <Lightbox
                                small={p2thumb}
                                large={p2}
                                hideDownload="true"
                                 alt="Persona 2: Katy"/></span>
                            <span className="image fit">
                            <Lightbox
                                small={s2thumb}
                                large={s2}
                                hideDownload="true"
                                 alt="Scenario 2: Katy"/></span>
                        </div>
                        <div className="col-4">
                            <h3 className="align-center"><strong>PERSONA 3</strong></h3>
                            <span className="image fit">
                            <Lightbox
                                small={p3thumb}
                                large={p3}
                                hideDownload="true"
                                 alt="Persona 3: JK"/></span>
                            <span className="image fit">
                            <Lightbox
                                small={s3thumb}
                                large={s3}
                                hideDownload="true"
                                 alt="Scennario 3: JK"/></span>
                        </div>
                    </div>
                </section>            
            
                <section id="five" className="main style2">
                    <div className="grid-wrapper">
                        <div className="col-12">
                            <header className="major">
                                <h2>LOW-FI</h2>
                            </header>
                            <p>Click the image to see the detail</p>
                        </div>
                        <div className="col-4">
                            <h3 className="align-center"><strong>V1.A</strong></h3>
                            <span className="image fit">
                                <Lightbox
                                small={lf1thumb}
                                large={lf1}
                                hideDownload="true"
                                 alt="Scennario 3: JK"/></span>
                        </div>
                        <div className="col-4">
                            <h3 className="align-center"><strong>V1.B</strong></h3>
                            <span className="image fit">
                                <Lightbox
                                small={lf2thumb}
                                large={lf2}
                                hideDownload="true"
                                 alt="Scennario 3: JK"/></span>
                        </div>
                        <div className="col-4">
                            <h3 className="align-center"><strong>V1.C</strong></h3>
                            <span className="image fit">
                                <Lightbox
                                small={lf3thumb}
                                large={lf3}
                                hideDownload="true"
                                 alt="Scennario 3: JK"/></span>
                        </div>
                        <div className="col-4">
                            <h3 className="align-center"><strong>V1.D</strong></h3>
                        <span className="image fit">
                                <Lightbox
                                small={lf4thumb}
                                large={lf4}
                                hideDownload="true"
                                 alt="Scennario 3: JK"/></span>
                        </div>
                        <div className="col-4">
                            <h3 className="align-center"><strong>V1.E</strong></h3>
                        <span className="image fit">
                                <Lightbox
                                small={lf5thumb}
                                large={lf5}
                                hideDownload="true"
                                 alt="Scennario 3: JK"/></span>
                        </div>
                    </div>
                </section>
                
                <section id="six" className="main style1">
                    <div className="grid-wrapper">
                        <div className="col-12">
                            <header className="major">
                                <h2>CRITIQUE</h2>
                            </header>
                        </div>
                        <div className="col-12">
                            <h3>CONTENT</h3>
                            <p>In our brainstorming critique, the main issue that needed to be addressed was the ethical implications of sharing the 
                                stories between platforms; additionally, we had to address the fact that we were initially lying to our players about 
                                what the game was. The forced us to questions if the game was made for the purpose of fun or for the purpose of research.<br/><br/>
                                After this evaluation, we clarified that our game was meant to be more educational, which was our major change.</p>
                        </div>
                        <div className="col-12">
                            <h3>LOW-FI PROTOTYPE</h3>
                            <p>In the second critique of our low-fi prototypes, the big choice we had to make was which prototype of the 5 took all our 
                                personas best into account. One of the biggest criticisms here was how detailed the stories and answers were going to be. 
                                We experimented between answer choices of true or false, or multiple choice. We addressed this by considering our personas. 
                                All three seemed like they wanted toe power to make their own decision and think through what they were reading (one persona 
                                loves social advocacy and wants to understand others, one is self-sufficient, and one is skeptical about information). Because 
                                our personas enjoy mental stimulation, we decided to keep multiple answers rather than a simple true and false.<br/><br/>
                                Additionally, this was the point where we started needing to address how much text on a single page there would be. 
                                Because the amount of text is overwhelming, we have decided to create them in boxes that help the user feel more in control. 
                                We accomplished this by creating a text box that you can open and close during the game.</p>
                        </div>
                    </div>
                </section>

                <section id="six" className="main style2">
                    <div className="grid-wrapper">
                        <div className="col-12">
                            <header className="major">
                                <h2>EVALUATION</h2>
                            </header>
                            <p>We were able to receive direct feedback from 4 people. Each team member conducted a cognitive walkthrough to understand 
                            what our users were thinking.</p>
                            <h3><strong>3 BIG TAKEAWAYS</strong></h3>
                            <ol>
                                <li>For user flow, users didn't understand that they were answering the same question twice. This was likely cuased by a lack of 
                                    instruction and poor naming of buttons
                                </li>
                                <li>Users were frustrated with the sharing feature of our webstie. At the end of the game, the flows between the 'finish' screen, 
                                    'feedback' screen, and 'sharing' screen were very disjointed. At times, it was difficult to access and go back to the screen 
                                    that you wanted to go to.
                                </li>
                                <li> Our design was boring and word heavy. It made it feel uninteresting to walk through our prototype. Users also didn't feel 
                                    like they were able to have freedom in exploring the prototype since it is very straightforward.</li>
                            </ol>
                            <h3><strong>CHANGES AFTER EVALUATION</strong></h3>
                            <ol>
                                <li>Our changes involved changing and adding additional hover effects to our design.</li>
                                <li>Additionally, we formatted the design of our results to better display the answers of other users.</li>
                                <li>We also addressed what came up in our evaluation sessions which included button naming, user flow of the share page, and updates to our micro-interactions.</li>
                                <li>Additionally, we updated the login page to make it more realistic based off of modern websites.</li>
                            </ol>
                        </div>
                    </div>
                </section>

                <section id="seven" className="main style1">
                    <div className="grid-wrapper">
                        <div className="col-12">
                            <header className="major">
                                <h2>HI-FI</h2>
                            </header>
                            <p>Click the image to see the detail</p>
                        </div>
                        <div className="col-6">
                            <span className="image fit">
                                <Lightbox
                                small={hf1}
                                large={hf1}
                                hideDownload="true"
                                 alt="Home"/></span>
                        </div>
                        <div className="col-6">
                            <span className="image fit">
                                <Lightbox
                                small={hf2}
                                large={hf2}
                                hideDownload="true"
                                 alt="Login"/></span>
                        </div>
                        <div className="col-6">
                            <span className="image fit">
                                <Lightbox
                                small={hf3}
                                large={hf3}
                                hideDownload="true"
                                 alt="Instruction"/></span>
                        </div>
                        <div className="col-6">
                            <span className="image fit">
                                <Lightbox
                                small={hf4}
                                large={hf4}
                                hideDownload="true"
                                 alt="Question"/></span>
                        </div>
                        <div className="col-6">
                            <span className="image fit">
                                <Lightbox
                                small={hf5}
                                large={hf5}
                                hideDownload="true"
                                 alt="Feedback"/></span>
                        </div>
                        <div className="col-6">
                            <span className="image fit">
                                <Lightbox
                                small={hf6}
                                large={hf6}
                                hideDownload="true"
                                 alt="Question Attempt 2"/></span>
                        </div>
                        <div className="col-6">
                            <span className="image fit">
                                <Lightbox
                                small={hf7}
                                large={hf7}
                                hideDownload="true"
                                 alt="Feedback after 2nd Attempt"/></span>
                        </div>
                        <div className="col-6">
                            <span className="image fit">
                                <Lightbox
                                small={hf8}
                                large={hf8}
                                hideDownload="true"
                                 alt="Result"/></span>
                        </div>
                        <div className="col-6">
                            <span className="image fit">
                                <Lightbox
                                small={hf9}
                                large={hf9}
                                hideDownload="true"
                                 alt="Result Score Pop Up"/></span>
                        </div>
                        <div className="col-6">
                            <span className="image fit">
                                <Lightbox
                                small={hf10}
                                large={hf10}
                                hideDownload="true"
                                 alt="Share"/></span>
                        </div>
                    </div>
                </section>
            
                <section id="eight" className="main style2">
                    <div className="grid-wrapper">
                        <div className="col-12">
                            <header className="major">
                                <h2>REFLECTION</h2>
                            </header>
                            <h3>DESIGN PROCESS</h3>
                            <p>Initial reflection thoughts is that we were more attentive to certain parts of the process than others. 
                                For example, we spent a lot of time figuring out the direction of our project even as we were working on wireframes.<br/><br/>
                                Additionally, it felt like our research was continuing through the late project iterations since we were focused on 
                                designing stories and scenarios for our prototype. We kept going back into answering questions like "How do we give 
                                feedback on answer choices," and "What scenarios incite bias and how do we keep that in mind."<br/><br/>
                                Overall, as a team, we did our best to incorporate a flexible process that was understanding towards one another.</p>
                        </div>
                        <div className="col-6">
                            <h3 className="align-center">RESEARCH</h3>
                            <p className="align-center">During research, we went in with an open mind since many of us were not familiar with the concept of transmedia, 
                                and only knew so much about misinformation. Here, our process was focused on our users, and we took them into high 
                                consideration when searching for the problem.</p>
                        </div>
                        <div className="col-6">
                            <h3 className="align-center">LOW-FI</h3>
                            <p className="align-center">When we reflect on the lo fi prototypes, we had split up the work and each of us did one lo-fi 
                            prototype. In our reflection, we should have each come up with multiple designs and created many more mock ups. </p>
                        </div>
                        <div className="col-6">
                            <h3 className="align-center">EVALUATION</h3>
                            <p className="align-center">Our evaluation was a point in our project where we were very un-invovled. Although we got helpful 
                            feedback on our design, much of it was out of frustration with our prototype, and if we were to do the project again, we would 
                            have solidified our evaluation process. </p>
                        </div>
                        <div className="col-6">
                            <h3 className="align-center">HI-FI</h3>
                            <p className="align-center">Reflecting on our hi-fi prototype, our process involved improving the overall design and incorporating 
                            the feedback from the evaluations rather than adding additional and needed features to our product. Our mentality started to become 
                            to finish the project rather than go back and make fundamental design changes.</p>
                        </div>
                    </div>
                </section>
                
                <section id="nine" className="main style1">
                    <div className="grid-wrapper">
                        <div className="col-12">
                            <header className="major">
                                <h2>CHALLENGES</h2>
                            </header>
                        </div>
                        <div className="col-4">
                            <h3 className="align-center">Project Direction Switch</h3>
                            <p className="align-center">During the beginning of our project, we had originally planned to focus on the spread of misinformation through social media. 
                                This was ethically inconsiderate because we were trying to design misinformation. This switch happened after our brainstorming 
                                feedback session.</p>
                        </div>
                        <div className="col-4">
                            <h3 className="align-center">UI Desing vs. Story Design</h3>
                            <p className="align-center">We focused a lot of our efforts on designing our stories. Even though this was an interaction design 
                            project, we spent a lot of time on the content of our project (researching stories, providing feedback, etc) when we should have 
                            paid more attention to the interactions in our UI.</p>
                        </div>
                        <div className="col-4">
                            <h3 className="align-center">Time Zone</h3>
                            <p className="align-center">We had a difficult time with our team having two students in Asia, one on the West Coast and one on 
                            the East Coast. This affected times that we were able to meet and collaborate. This caused our work to be distributed 
                            (which caused disjointed work).</p>
                        </div>
                    </div>
                </section>
            
                <section id="ten" className="main style2">
                    <div className="grid-wrapper">
                        <div className="col-12">
                            <header className="major">
                                <h2>FUTURE WORK</h2>
                            </header>
                            <p>We would be interested in testing our design with users to see if their answers are affected by other people's results.<br/><br/>
                            Additionally, we would be interested in incorporating more transmedia elements to our design; this could include programmed 
                            mini games, comic strips, and other digital media elements.<br/><br/>
                            Practically, we would improve the design of NewsPixel. This would include updating our newspaper inspired design as well as 
                            experimenting with a wider variety of fonts and colors.</p>
                        </div>
                    </div>
                </section>
            </Layout>
        );
    }
}

export default Homepage;